import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Folder, Cpu, Layers, FileText } from 'lucide-react';
import { useCurrentUser } from '@/hooks/redux';
import { useGetDashboardStatsQuery, useGetFileHistoryQuery } from '@/store/api/fileHistoryApi';
import MetricCard from '@/components/buddy/MetricCard';

export function DashboardPage() {
  const { t } = useTranslation();
  const user = useCurrentUser();

  const { data, isLoading } = useGetDashboardStatsQuery();

  const metrics = [
    {
      title: 'ALL FILES',
      folder: 'all',
      icon: Folder,
      value: data?.total || 0,
    },
    {
      title: 'TECH',
      folder: 'tech',
      icon: Cpu,
      value: data?.tech || 0,
    },
    {
      title: 'SEMI TECH',
      folder: 'semi',
      icon: Layers,
      value: data?.semiTech || 0,
    },
    {
      title: 'NON TECH',
      folder: 'non',
      icon: FileText,
      value: data?.nonTech || 0,
    },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">{t('dashboard.welcome')}</h2>
        <p className="text-muted-foreground">
          {user?.name && `Welcome back, ${user.name}! `}
          Here's your file analytics overview.
        </p>
      </div>

      {isLoading && <p className="text-sm text-muted-foreground">Loading analytics...</p>}

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {metrics.map((metric) => (
          <MetricCard
            key={metric.title}
            title={metric.title}
            value={metric.value}
            icon={metric.icon}
            folder={metric.folder}
          />
        ))}
      </div>
    </div>
  );
}
